<div class="shw-on-web">
  <ul class="list-inline f-light ul-style ">
    <li class="list-inline-item">
      <a href="Filter By" class="filter-by">
        Filter By:
      </a>
    </li>
    <li class="list-inline-item text-right float-right">
      <a href="javascript:void(0)" (click)="clearAll()">
        <u>
          Clear All
        </u>
      </a>
    </li>
  </ul>
  <div class="new-checkbox">
    <p>
      <label>
        <input type="checkbox" [checked]="show_wheel_weight"
          (change)="toggleHideShowFilter($event, 'wheel_weight')" /><span>Show Wheel Weight</span>
      </label>
    </p>
    <p>
      <label>
        <input type="checkbox" [checked]="show_center_bore"
          (change)="toggleHideShowFilter($event, 'hub_bore')" /><span>Show Center Bore Size</span>
      </label>
    </p>
    <p *ngIf="is_show_hub_bore">
      <label>
        <input type="checkbox" [checked]="hub_bore_filtered" (change)="onFilter($event, null, false, true)"
          value="hub_bore|{{hub_bore}}" /><span>Show Only Hub Centric</span>
      </label>
    </p>
    <p *ngIf="!profileData?.is_hide_out_of_stock">
      <label class="hide_stock_label d-flex align-items-center">
        <input type="checkbox" #hideOutOfStock (change)="onFilter($event, null, false, true)"
          value="hide_out_of_stock|1" />
        <span>Hide Out of Stock</span>
      </label>
    </p>
    <p *ngIf="profileData?.is_hide_out_of_stock">
      <label class="hide_stock_label d-flex align-items-center">
        <input type="checkbox" #showOutOfStock (change)="onFilter($event, null, false, true)"
          value="show_out_of_stock|1" />
        <span>Show Out of Stock</span>
      </label>
    </p>
    <p>
      <label>
        <input type="checkbox" value="" (change)="onFilter($event, null, false, true)"
          value="exclude_supplier_products|1" /><span>Exclude Supplier Stock</span>
      </label>
    </p>
  </div>
  <div class="bs-example filters">
    <div class="accordion left-sidebar mb-5" id="accordionExample">
      <div class="card">
        <div class="card-header" id="headingZero">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseZero">
              <i class="fa fa-plus"></i>
              Minimum Quantity
            </button>
          </h2>
        </div>
        <div id="collapseZero" class="collapse" aria-labelledby="headingZero" data-parent="#accordionExample">
          <div class="card-body">
            <div class="d-flex flex-row align-items-center justify-content-between">
              <div class="btn-group quantity_update_filter" role="group">
                <button type="button" class="btn text-danger" (click)="updateQty($event, 0)">
                  <i class="fa fa-minus"></i>
                </button>
                <input class="form-control text-center minimum-qty-input" style="width: 60px" value="1">
                <button type="button" class="btn text-danger" (click)="updateQty($event, 1)">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
              <button class="btn btn-dark px-4" (click)="onFilter($event, null, true)"
                value="min_quantity|1">Apply</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="filters?.brand">
        <div class="card-header" id="headingSeven">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSeven">
              <i class="fa fa-plus"></i>
              Brand
            </button>
          </h2>
        </div>
        <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
          <div class="card-body">
            <p *ngFor="let filter of filters.brand">
              <label>
                <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                  value="brand|{{filter.name}}" />
                <span>{{ filter.name }}</span>
              </label>
            </p>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="filters?.rim_diameter">
        <div class="card-header" id="headingOne">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseOne">
              <i class="fa fa-plus"></i>
              Diameter
            </button>
          </h2>
        </div>
        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
          <div class="card-body">
            <p *ngFor="let filter of filters.rim_diameter">
              <label>

                <input type="radio" [checked]="filter?.checked" name="diameter" (click)="onFilter($event, filter)"
                  value="rim_diameter|{{filter.name}}" /> <span>{{ filter.name }}</span>
              </label>
            </p>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="filters?.rim_width">
        <div class="card-header" id="headingTwo">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo">
              <i class="fa fa-plus"></i>
              Width
            </button>
          </h2>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
          <div class="card-body">
            <p *ngFor="let filter of filters.rim_width">
              <label>
                <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                  value="rim_width|{{filter.name}}" /> <span>{{ filter.name }}</span></label>
            </p>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="filters?.bolt_pattern">
        <div class="card-header" id="headingSix">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSix">
              <i class="fa fa-plus"></i>
              Bolt Pattern
            </button>
          </h2>
        </div>
        <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
          <div class="card-body">
            <p *ngFor="let filter of filters.bolt_pattern">
              <label *ngIf="filter.name"><input type="checkbox" [checked]="filter?.checked"
                  (click)="onFilter($event, filter)" value="bolt_pattern|{{filter.name}}" /> <span>{{ filter.name
                  }}</span></label>
            </p>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="offsetFilter">
        <div class="card-header" id="headingTen">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTen">
              <i class="fa fa-plus"></i>
              Offset
            </button>
          </h2>
        </div>
        <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordionExample">
          <div class="card-body">
            <!-- <p *ngFor="let filter of offsetFilter"> -->
            <!-- <label>
                <input type="radio" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                  value="offset|{{filter.name}}" />
                {{ filter.name }}
              </label>
            </p>
            <p><input type="number" min="-180" max="70" (keyup)="onFilter($event, null)" name="offset"
                [(ngModel)]="offsetMin" placeholder="-180" />mm to <input type="number" min="-180" max="70"
                (keyup)="onFilter($event, null)" [(ngModel)]="offsetMax" placeholder="70" />mm
            </p> -->

            <p class="min-and-max">
              <input type="number" id="minOffset" placeholder="Min Offset" /> -
              <input type="number" id="maxOffset" placeholder="Max Offset" />
            </p>
            <button class="btn btn-dark px-4 w-100" (click)="onFilter($event, null, true)" value="offset|1">Apply
            </button>

          </div>
        </div>
      </div>
      <div class="card" *ngIf="filters?.center_bore">
        <div class="card-header" id="headingNine">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseNine">
              <i class="fa fa-plus"></i>
              Center Bore
            </button>
          </h2>
        </div>
        <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample">
          <div class="card-body">
            <!-- <p *ngFor="let filter of filters.center_bore">
                            <label>
                                <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                                    value="center_bore|{{filter.name}}" />
                                {{ filter.name }}
                            </label>
                        </p> -->
            <select (change)="onFilter($event, null)" class="new-select-box select-box-style">
              <option value="center_bore|" selected>Minimum Center Bore</option>
              <option *ngFor="let filter of filters.center_bore" value="center_bore|{{filter.name}}"
                [selected]="filter?.checked">
                <span>{{ filter.name }}</span>
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="filters?.load_rating">
        <div class="card-header" id="headingEight">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseEight">
              <i class="fa fa-plus"></i>
              Load Rating
            </button>
          </h2>
        </div>
        <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordionExample">
          <div class="card-body">
            <!-- <p *ngFor="let filter of filters.load_rating">
                            <label>
                                <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                                    value="load_rating|{{filter.name}}" />
                                {{ filter.name }}
                            </label>
                        </p> -->
            <select (change)="onFilter($event, null)" class="new-select-box select-box-style">
              <option value="load_rating|" selected>Minimum Load Rating</option>
              <option *ngFor="let filter of filters.load_rating" value="load_rating|{{filter.name}}">
                {{ filter.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="filters?.construction">
        <div class="card-header" id="headingFour">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour">
              <i class="fa fa-plus"></i>
              Construction
            </button>
          </h2>
        </div>
        <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
          <div class="card-body">
            <p *ngFor="let filter of filters.construction">
              <label>
                <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                  value="construction|{{filter.name}}" /> <span>{{ filter.name }}</span></label>
            </p>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="filters?.finish">
        <div class="card-header" id="headingFive">
          <h2 class="mb-0">
            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive">
              <i class="fa fa-plus"></i>
              Finish
            </button>
          </h2>
        </div>
        <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
          <div class="card-body">
            <p *ngFor="let filter of filters.finish">
              <label>
                <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                  value="finish|{{filter.name}}" /> <span>{{ filter.name }}</span></label>
            </p>
          </div>
        </div>
      </div>









    </div>
  </div>
</div>

<div class="show-on-mobl">
  <ul class="list-inline f-light ul-style ">
    <li class="list-inline-item">
      <a href="javascript:void(0);" class="fltr-shw">
        Filter By
      </a>
    </li>

  </ul>

  <a href="javascript:;" class="btn btn-filter w-50 mb-2" (click)="showFilters = !showFilters">
    <i class="fa fa-filter"></i>
    Filters
  </a>

</div>
<!-- <li class="list-inline-item text-right float-right">
            <a href="javascript:void(0)" (click)="clearAll()">
                <u>
    Clear All
  </u>
            </a>
        </li> -->
<div class="shwmbl-flter" *ngIf="showFilters">
  <div class="fltr-layer"></div>
  <div class="shwmbl-flter-outer">
    <!-- <div class="fltr-layer"></div> -->
    <div class="shwmbl-flter-innr d-flex flex-column">
      <div class="shwmbl-flter-tp">
        <h4 class="small-21">Filters</h4>
        <a href="javascript:void(0);" (click)="clearAll()" class="btn btn-filter">Clear</a>
        <a href="javascript:void(0);" class="btn btn-filter" (click)="showFilters = !showFilters">Done</a>
      </div>
      <div class="new-checkbox px-3 new-checkbox">
        <p>
          <label>
            <input type="checkbox" [checked]="show_wheel_weight"
              (change)="toggleHideShowFilter($event, 'wheel_weight')" /><span>Show Wheel Weight</span>
          </label>
        </p>
        <p>
          <label>
            <input type="checkbox" [checked]="show_center_bore"
              (change)="toggleHideShowFilter($event, 'hub_bore')" /><span>Show Center Bore Size</span>
          </label>
        </p>
        <p *ngIf="is_show_hub_bore">
          <label>
            <input type="checkbox" [checked]="hub_bore_filtered" (change)="onFilter($event, null, false, true)"
              value="hub_bore|{{hub_bore}}" /><span>Show Only Hub Centric</span>
          </label>
        </p>
        <p *ngIf="!profileData?.is_hide_out_of_stock">
          <label class="hide_stock_label d-flex align-items-center">
            <input type="checkbox" #hideOutOfStock (change)="onFilter($event, null, false, true)"
              value="hide_out_of_stock|1" />
            <span>Hide Out of Stock</span>
          </label>
        </p>
        <p *ngIf="profileData?.is_hide_out_of_stock">
          <label class="hide_stock_label d-flex align-items-center">
            <input type="checkbox" #showOutOfStock (change)="onFilter($event, null, false, true)"
              value="show_out_of_stock|1" />
            <span>Show Out of Stock</span>
          </label>
        </p>
        <p>
          <label>
            <input type="checkbox" value="" (change)="onFilter($event, null, false, true)"
              value="exclude_supplier_products|1" /><span>Exclude Supplier Stock</span>
          </label>
        </p>
      </div>
      <div class="bs-example filters">
        <div class="accordion left-sidebar mb-5" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingZero">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseZero">
                  <i class="fa fa-plus"></i>
                  Minimum Quantity
                </button>
              </h2>
            </div>
            <div id="collapseZero" class="collapse" aria-labelledby="headingZero" data-parent="#accordionExample">
              <div class="card-body">
                <div class="d-flex flex-row align-items-center justify-content-between">
                  <div class="btn-group quantity_update_filter" role="group">
                    <button type="button" class="btn text-danger" (click)="updateQty($event, 0)">
                      <i class="fa fa-minus"></i>
                    </button>
                    <input class="form-control text-center minimum-qty-input" style="width: 60px" value="1">
                    <button type="button" class="btn text-danger" (click)="updateQty($event, 1)">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  <button class="btn btn-dark px-4" (click)="onFilter($event, null, true)"
                    value="min_quantity|1">Apply</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="filters?.brand">
            <div class="card-header" id="headingSeven">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link collapsed" data-toggle="collapse"
                  data-target="#collapseSeven">
                  <i class="fa fa-plus"></i>
                  Brand
                </button>
              </h2>
            </div>
            <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
              <div class="card-body">
                <p *ngFor="let filter of filters.brand">
                  <label>
                    <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                      value="brand|{{filter.name}}" />
                    <span>{{ filter.name }}</span>
                  </label>
                </p>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="filters?.rim_diameter">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseOne">
                  <i class="fa fa-plus"></i>
                  Diameter
                </button>
              </h2>
            </div>
            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="card-body">
                <p *ngFor="let filter of filters.rim_diameter">
                  <label>

                    <input type="radio" [checked]="filter?.checked" name="diameter" (click)="onFilter($event, filter)"
                      value="rim_diameter|{{filter.name}}" /> <span>{{ filter.name }}</span>
                  </label>
                </p>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="filters?.rim_width">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo">
                  <i class="fa fa-plus"></i>
                  Width
                </button>
              </h2>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <div class="card-body">
                <p *ngFor="let filter of filters.rim_width">
                  <label>
                    <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                      value="rim_width|{{filter.name}}" /> <span>{{ filter.name }}</span></label>
                </p>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="filters?.bolt_pattern">
            <div class="card-header" id="headingSix">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSix">
                  <i class="fa fa-plus"></i>
                  Bolt Pattern
                </button>
              </h2>
            </div>
            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
              <div class="card-body">
                <p *ngFor="let filter of filters.bolt_pattern">
                  <label *ngIf="filter.name"><input type="checkbox" [checked]="filter?.checked"
                      (click)="onFilter($event, filter)" value="bolt_pattern|{{filter.name}}" /> <span>{{ filter.name
                      }}</span></label>
                </p>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="offsetFilter">
            <div class="card-header" id="headingTen">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTen">
                  <i class="fa fa-plus"></i>
                  Offset
                </button>
              </h2>
            </div>
            <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordionExample">
              <div class="card-body">
                <!-- <p *ngFor="let filter of offsetFilter"> -->
                <!-- <label>
                    <input type="radio" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                      value="offset|{{filter.name}}" />
                    {{ filter.name }}
                  </label>
                </p>
                <p><input type="number" min="-180" max="70" (keyup)="onFilter($event, null)" name="offset"
                    [(ngModel)]="offsetMin" placeholder="-180" />mm to <input type="number" min="-180" max="70"
                    (keyup)="onFilter($event, null)" [(ngModel)]="offsetMax" placeholder="70" />mm
                </p> -->

                <p class="min-and-max">
                  <input type="number" id="minOffset" placeholder="Min Offset" /> -
                  <input type="number" id="maxOffset" placeholder="Max Offset" />
                </p>
                <button class="btn btn-dark px-4 w-100" (click)="onFilter($event, null, true)" value="offset|1">Apply
                </button>

              </div>
            </div>
          </div>
          <div class="card" *ngIf="filters?.center_bore">
            <div class="card-header" id="headingNine">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseNine">
                  <i class="fa fa-plus"></i>
                  Center Bore
                </button>
              </h2>
            </div>
            <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample">
              <div class="card-body">
                <!-- <p *ngFor="let filter of filters.center_bore">
                                <label>
                                    <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                                        value="center_bore|{{filter.name}}" />
                                    {{ filter.name }}
                                </label>
                            </p> -->
                <select (change)="onFilter($event, null)" class="new-select-box select-box-style">
                  <option value="center_bore|" selected>Minimum Center Bore</option>
                  <option *ngFor="let filter of filters.center_bore" value="center_bore|{{filter.name}}"
                    [selected]="filter?.checked">
                    <span>{{ filter.name }}</span>
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="filters?.load_rating">
            <div class="card-header" id="headingEight">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link collapsed" data-toggle="collapse"
                  data-target="#collapseEight">
                  <i class="fa fa-plus"></i>
                  Load Rating
                </button>
              </h2>
            </div>
            <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordionExample">
              <div class="card-body">
                <!-- <p *ngFor="let filter of filters.load_rating">
                                <label>
                                    <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                                        value="load_rating|{{filter.name}}" />
                                    {{ filter.name }}
                                </label>
                            </p> -->
                <select (change)="onFilter($event, null)" class="new-select-box select-box-style">
                  <option value="load_rating|" selected>Minimum Load Rating</option>
                  <option *ngFor="let filter of filters.load_rating" value="load_rating|{{filter.name}}">
                    {{ filter.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="card" *ngIf="filters?.construction">
            <div class="card-header" id="headingFour">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour">
                  <i class="fa fa-plus"></i>
                  Construction
                </button>
              </h2>
            </div>
            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
              <div class="card-body">
                <p *ngFor="let filter of filters.construction">
                  <label>
                    <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                      value="construction|{{filter.name}}" /> <span>{{ filter.name }}</span></label>
                </p>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="filters?.finish">
            <div class="card-header" id="headingFive">
              <h2 class="mb-0">
                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive">
                  <i class="fa fa-plus"></i>
                  Finish
                </button>
              </h2>
            </div>
            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
              <div class="card-body">
                <p *ngFor="let filter of filters.finish">
                  <label>
                    <input type="checkbox" [checked]="filter?.checked" (click)="onFilter($event, filter)"
                      value="finish|{{filter.name}}" /> <span>{{ filter.name }}</span></label>
                </p>
              </div>
            </div>
          </div>









        </div>
      </div>
    </div>
  </div>
</div>